/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

export type FiscalizeDocumentType = typeof FiscalizeDocumentType[keyof typeof FiscalizeDocumentType];


export const FiscalizeDocumentType = {
  invoice: 'invoice',
  estimate: 'estimate',
  credit_note: 'credit_note',
  advance_invoice: 'advance_invoice',
  delivery_note: 'delivery_note',
} as const;
